<template>
  <div class="answer-h5-downloadable antialiased">
    <ul v-for="(f, idx) in files">
      <li class="flex flex-nowrap justify-between items-center border border-solid border-black my-4 p-4">
        <div class="flex flex-nowrap items-center">
          <van-icon name="description" class="self-start mt-1" />
          <div class="px-4 font-normal break-words text-justify">{{ f.name }}</div>
        </div>
        <!-- <van-icon v-if="isMobileBrowser" class="self-start mt-1" name="down" @click="downloadFile(f)"/> -->
        <van-button :class="['flex-shrink-0', 'copy_' + questionId + '_' + idx]" type="default" @click="onClickCopyUrl(f)">
          <span class="text-small leading-18">复制链接<br />浏览器打开</span>
        </van-button>
        <!-- <div :id="'url_' + questionId + '_' + idx" class="hidden">{{originUrl + '/fill/api/v1/download?fileName=' + f.url }}</div> -->
      </li>
    </ul>
  </div>
</template>

<script>
import { Notify } from 'vant'
export default {
  name: 'Downloadable',
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  computed: {
    files() {
      return this.question.content.file
    },
    questionId() {
      return this.question.id
    },
    isMobileBrowser() {
      return this.$bus.currentBrowserInfo.isPc
    },
    originUrl() {
      return window.location.origin
    }
  },
  methods: {
    fileUrl(file) {
      const fileNameArr = file.name.split('.')
      fileNameArr.pop()
      return this.originUrl + '/fill/api/v1/downloadWithName?fileName=' + file.url + '&downLoadName=' + fileNameArr.join('.')
    },
    downloadFile(file) {
      if (this.isMobileBrowser) {
        var a = document.createElement('a')
        a.href = this.fileUrl(file)
        a.click()
      }
    },

    onClickCopyUrl(file) {
      let input = document.createElement('input')
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', this.fileUrl(file))
      document.body.appendChild(input)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        Notify({ type: 'success', message: '复制成功' })
      } else {
        Notify({ type: 'danger', message: '复制失败' })
      }
      document.body.removeChild(input)
    }
  }
}
</script>
